import React, { useState, useCallback, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../authcontext/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TextBlock from '../form/blocks/TextBlock';
import axios from 'axios';
import { config } from '../../utils/config';
import CommonModal from './CommonModal';

export default function LoginModal() {

    const authData = useContext(AuthContext)
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usernameError, setUsernameError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [errorModal, setErrorModal] = useState(false)

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    // form validation
    const checkUsername = useCallback(() => {
        if (username.length < 4) {
            setUsernameError("username must have at least 4 characters");
        } else { setUsernameError("") }
    }, [username.length])

    const checkPassword = useCallback(() => {
        if (password.length < 4) {
            setPasswordError("password must have at least 4 characters")
        } else { setPasswordError("") }
    }, [password])

    const googleLogin = () => {
        window.open(`${config.apiBaseUrl}/google-login/auth/google`, '_self');
    }

    const verifyUser = useCallback(async () => {

        if (username && password && !usernameError && !passwordError) {

            try {
                const response = await axios.post(`${config.apiBaseUrl}/user-login/`, {
                    username,
                    password
                }, { withCredentials: true });
                // console.log("access token:", response.data.accessToken)
                const token = response.data.accessToken
                authData.updateToken(token)

                // Handle the successful login response
                if (token) {

                    const userData = await axios.get(`${config.apiBaseUrl}/user-login/profile`, {

                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }, { withCredentials: true });

                    if (userData) {
                        authData.updateUserDetail(userData.data)
                        authData.updateIsAuth(true)
                        navigate('/')

                    } else {
                        console.log("unable to authenticate")
                    }
                } else {
                    setErrorModal(true)
                }

            } catch (error) {
                console.log(error)
            }

        } else {
            setErrorModal(true)
            console.log("unable to authenticate with server")
        }


    }, [password, username, authData, passwordError, usernameError, navigate])



    return (<>


        <Button variant="danger" size="sm" onClick={handleShow}>
            View Bidding Activity
        </Button>

        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >

            <Modal.Header closeButton>
                <Modal.Title>Login to View Bidding</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className="container m-3">
                    <h5 className="text-center">Login</h5>
                    <span onKeyUp={checkUsername}>
                        <TextBlock label={"Username"} updateParentValue={(value) => { setUsername(value) }} errorMessage={usernameError} />
                    </span>
                    <span onKeyUp={checkPassword}>
                        <TextBlock type="password" label={"Password"} updateParentValue={(value) => { setPassword(value) }} errorMessage={passwordError} />
                    </span>
                    <div>
                        <Button variant="danger" onClick={verifyUser}>Submit</Button>
                        <button className="btn btn-danger" onClick={googleLogin}>Google Login</button>
                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="my-3">
                    <div>
                        <Link to="/register" className="link-danger">New to the platform? Register Here </Link>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>

        <CommonModal title="Unable to Authenticate" message="Please Check Your Username and Password" show={errorModal} handleClose={() => { setErrorModal(false) }} />


    </>)
}